import { useEffect, useState } from 'react'

// FORM
import { BwmSelect } from '../form/BwmSelect'

export function NumberOfResultsSelector(props) {
  const defaultOptions = [10, 20, 50, 100]
  const options = props.options || defaultOptions
  const [selected, setSelected] = useState(props.selected || options[1])

  useEffect(() => {
    setSelected(props.selected)
  }, [props.selected])

  const handleChange = (value) => {
    props.onChange(value?.id)
  }

  const getOptions = () => {
    if (options?.length > 0) {
      return options.map((option) => {
        return { id: option, description: option }
      })
    }
  }

  return (
    <>
      <BwmSelect
        disabled={props.loading}
        options={getOptions()}
        className="star-table-per-page-select"
        optionValue="id"
        optionLabel="description"
        isClearable={false}
        isSearchable={false}
        value={selected}
        onChange={handleChange}
      />
    </>
  )
}
